import { createSlice } from '@reduxjs/toolkit';

import { giftRegistryItemConfirmResponse } from '../gift-registry/reducer';
import { type IGiftRegistryItemConfirmResponse } from '../gift-registry/types';
import { createResponse } from '../order/reducer';
import { type CreateOrderResponse } from '../order/types';
import { type ILegalState } from './types';

const initialState: ILegalState = {
  seller: null,
  terms: null,
  privacyPolicy: null,
};

const legalSlice = createSlice({
  name: 'legal',
  initialState,
  reducers: {},
  extraReducers: (builder): void => {
    builder.addCase(
      createResponse,
      (state: ILegalState, action: CreateOrderResponse): void => {
        if (action.payload.terms) {
          state.terms = action.payload.terms;
        }
      },
    );
    builder.addCase(
      giftRegistryItemConfirmResponse,
      (state: ILegalState, action: IGiftRegistryItemConfirmResponse): void => {
        if (action.payload.terms) {
          state.terms = action.payload.terms;
        }
      },
    );
  },
});

export default legalSlice.reducer;
